import React from 'react';
import { makeStyles, createStyles } from '@material-ui/core/styles';

const recordingLogo = require("../../images/recordinglogo.png")
const useStyles = makeStyles(() =>
  createStyles({
   image:{
    
    // left:'5em',
    // right:0,
    // top:'131rem',
   
    // width:200,
    // display: 'inline-block',
       top:'-6rem',
       left:'2em',
       right:0,
       width:'15rem',
       display:'flex',
       alignContent:'baseline',
       position:'relative',
       justifyItems:'flex-start',
    '@media only screen and (max-width: 959px)': {
        display: 'none',
    },
   }
    
  })
);
const RecordingLogo = () => {
  const classes = useStyles();

    return (
        <img 
        src={recordingLogo} 
        alt="recordingLogo" 
        className={classes.image}
        />
    );
};
export default RecordingLogo;